module.exports = __webpack_public_path__ + "static/media/goblin_bomber.cb828b97.svg";